import { render, staticRenderFns } from "./yishengDetails.vue?vue&type=template&id=71be1142&scoped=true"
import script from "./yishengDetails.vue?vue&type=script&lang=js"
export * from "./yishengDetails.vue?vue&type=script&lang=js"
import style0 from "./yishengDetails.vue?vue&type=style&index=0&id=71be1142&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be1142",
  null
  
)

export default component.exports